import type * as Types from "@sinch/types/sinch.types";

export type CalculatedRateItems = {
  total: number;
  components: {
    amount?: number;
    component: string;
    parentRateAmount?: number | null;
    ratelistNodeId?: string;
    total: number;
    unit?: number | null;
    unitName?: Types.UnitName | null;
    rateUnitName?: string;
  }[];
};

export const CATEGORY_KEY = "MasterCategory" as const;

export type MaterCategory = typeof CATEGORY_KEY;
